<template lang="pug">
v-row.mb-8(v-if="canPublish")
    v-col(cols="12")
        Subtitle(:text="t$('.semester_program')")
        TextBody.mb-2(:text="infoText")
        v-switch.mt-0(v-model="isPublic", inset)
            template(v-slot:label)
                TextBody(
                    :text="t$('.add_to_semester_program')",
                    large
                )
</template>

<script lang="ts">
import TextBody from "../UI/TextBody.vue"
import Subtitle from "../UI/Subtitle.vue"
import { PanelIdentifier } from "features/events/form/event-form.types"
import {
  computed,
  defineComponent,
  inject,
  watch,
  WritableComputedRef,
} from "vue"
import EventFormService from "features/events/form/event-form.service"
import { EventForm } from "components/EventForm/EventForm.vue"
import useTranslate from "features/common/translate/concerns/useTranslate"
import { usePermissionCheck } from "features/common/permissions/usePermissionCheck"
import { ClientAbility } from "suus-api"
const PublishingFields = defineComponent({
  name: "PublishingFields",
  components: { TextBody, Subtitle },
  computed: {
    infoText(): string {
      return this.t$("components.event_form.semester_program_info_text")
    },
  },
  setup() {
    const { t$ } = useTranslate("components.event_form")

    const eventFormService =
      inject<EventFormService<EventForm>>("EventFormService")

    eventFormService.registerProperty({
      name: "is_public",
    })

    const isPublic: WritableComputedRef<boolean> = computed({
      get(): boolean {
        return !!eventFormService.getFormValue("is_public").value
      },
      set(value: boolean): void {
        eventFormService.setFormValue("is_public", !!value)
      },
    })

    const isHidden = computed(
      () => eventFormService.getFormValue("nonmember_access").value === "hidden"
    )

    watch(isHidden, (value) => {
      if (value) {
        isPublic.value = false
      }
    })

    const { hasClientPermission } = usePermissionCheck()
    const canPublish = computed(
      () =>
        !isHidden.value &&
        hasClientPermission(ClientAbility.ManageOpenEvents).value
    )

    return {
      isPublic,
      t$,
      canPublish,
    }
  },
})

export default PublishingFields

export const PublishingFieldsDefinition = {
  key: "publish",
  component: PublishingFields,
  id: PanelIdentifier.PUBLISHING,
}
</script>
